var map = {
	"./1.svg": 445,
	"./2.svg": 446,
	"./3.svg": 447,
	"./4.svg": 448,
	"./courses/ai.png": 606,
	"./courses/computer_literacy.png": 607,
	"./courses/frontend.png": 608,
	"./courses/game_design.png": 609,
	"./courses/gamedev.png": 610,
	"./courses/graphic_design.png": 611,
	"./courses/main.png": 612,
	"./courses/predprinimatelstvo.png": 613,
	"./courses/programming_basics.png": 614,
	"./courses/python.png": 615,
	"./courses/scratch.png": 616,
	"./courses/unity.png": 617,
	"./courses/video_content.png": 618,
	"./courses/videoblogging.png": 619,
	"./courses/web-razrabotka.png": 620,
	"./courses/webdev.png": 621,
	"./coursesNew/ai.png": 494,
	"./coursesNew/computer_literacy.png": 495,
	"./coursesNew/ege-informatika-desk.png": 421,
	"./coursesNew/ege-informatika.png": 422,
	"./coursesNew/frontend.png": 496,
	"./coursesNew/game_design.png": 497,
	"./coursesNew/graphic_design.png": 498,
	"./coursesNew/math-desk.png": 423,
	"./coursesNew/math.png": 424,
	"./coursesNew/predprinimatelstvo.png": 499,
	"./coursesNew/programming_basics.png": 500,
	"./coursesNew/python.png": 501,
	"./coursesNew/scratch.png": 502,
	"./coursesNew/unity.png": 503,
	"./coursesNew/videoblogging.png": 504,
	"./coursesNew/web-razrabotka.png": 505,
	"./cube.svg": 622,
	"./cursor1.svg": 416,
	"./cursor2.svg": 417,
	"./cursor3.svg": 418,
	"./cursor4.svg": 419,
	"./enter.svg": 623,
	"./globe.svg": 624,
	"./outbreak.svg": 625,
	"./puzzle.svg": 626,
	"./story1.png": 627,
	"./story2.png": 628,
	"./story3.png": 629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 847;